import { Generator, GeneratorMetaData } from "../types";
import { startCase } from "lodash-es";

export const schemaUtils = {
  getSchemaKey(generatorName: string, prefix = "create") {
    return `${prefix}::${generatorName.split(" ")[0].toLowerCase()}`;
  },
  getGenerators(generators: Generator[]) {
    const result: GeneratorMetaData[] = [];

    for (let idx = 0; idx < generators.length; idx++) {
      const metaData: GeneratorMetaData = {
        name: generators[idx].name,
        type: generators[idx].type,
      };
      result.push(metaData);
    }
    return result;
  },
  getFeatures(schema: Generator) {
    const features: string[] = [];
    const featureTypes = schema.features;
    for (const featureType of featureTypes) {
      features.push(startCase(featureType.name));
    }

    return features;
  },
};
